let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYjNa")).then(() => parcelRequire('ebauY'));